export default "__VITE_ASSET__23297d5d__"